import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const modalStyle = css`
  cse-modal {
    --cse-modal-header-background-color: ${csColorBackground.primary};
    --cse-modal-header-padding-y: 0;
    --cse-modal-header-padding-x: 0;
  }

  .configurator-modal-header {
    box-sizing: border-box;
    width: 100%;
    padding: ${csSpacing.spacing07} ${csSpacing.spacing07} ${csSpacing.spacing06};
    border-bottom: 1px solid rgb(227, 230, 236);
    text-align: left;
  }

  .configurator-modal-title {
    --cs-font-heading-3-font-size: 18px;
    --cs-font-heading-3-font-size-mobile: 18px;
  }

  .configurator-modal-description {
    --cs-font-body-s-font-size: 13px;
    --cs-font-body-s-font-size-mobile: 13px;
    --cse-text-color: rgb(107, 115, 133);
  }
`
